import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getMemberToken } from "./memberSession";

export default function MemberProtectedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        getMemberToken() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/member/auth/login" />
        )
      }
    />
  );
}

